import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { Icon, InputWithIcon, BackdropLoader, toast, BasicTooltip } from '@livable/saas-react-components';
import { Button, Container, TextField, Typography } from '@mui/material';
import { observer } from 'mobx-react-lite';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { PropertiesBatchActions } from './PropertiesBatchActions';
import { PropertiesDataGrid } from './PropertiesDataGrid';
import { CreateEditPortfolioModal } from 'src/components/shared/CreateEditPortfolioModal';
import { PortfolioActionsMenu } from './PortfolioActionsMenu';
import useStyles from './styles';
import { useStore } from 'src/stores';
import { Link as RouterLink } from 'react-router-dom';
import { SimpleConfirmationModal } from 'src/components/shared/SimpleConfirmationModal';
export const PropertiesTable = observer(_ref => {
  var _deleteModalProps$sel;
  let selectedPortfolio = _ref.selectedPortfolio,
    propertiesList = _ref.propertiesList,
    isLoadingExt = _ref.isLoadingExt,
    triggerRefresh = _ref.triggerRefresh,
    handleShowEnrollModal = _ref.handleShowEnrollModal,
    setShowEnrollModalSelectedPropertyId = _ref.setShowEnrollModalSelectedPropertyId,
    isSelectAllPropertiesEnabled = _ref.isSelectAllPropertiesEnabled,
    handleShowManageAccessModal = _ref.handleShowManageAccessModal,
    handleShowAutoBillingBatchModalModal = _ref.handleShowAutoBillingBatchModalModal;
  const store = useStore();
  const classes = useStyles();
  const _useTranslation = useTranslation(),
    t = _useTranslation.t;
  const _useState = useState([]),
    _useState2 = _slicedToArray(_useState, 2),
    selectedRows = _useState2[0],
    setSelectedRows = _useState2[1];
  const _useState3 = useState(''),
    _useState4 = _slicedToArray(_useState3, 2),
    searchKey = _useState4[0],
    setSearchKey = _useState4[1];
  const _useState5 = useState(false),
    _useState6 = _slicedToArray(_useState5, 2),
    isDeletePortfolioModalOpen = _useState6[0],
    setIsDeletePortfolioModalOpen = _useState6[1];
  const _useState7 = useState({}),
    _useState8 = _slicedToArray(_useState7, 2),
    deleteModalProps = _useState8[0],
    setDeleteModalProps = _useState8[1];
  const deletePortfolioHandler = async () => {
    await store.portfolios.deletePortfolioAsync.run({
      portfolioId: deleteModalProps === null || deleteModalProps === void 0 ? void 0 : deleteModalProps.portfolioId
    }).then(resp => {
      if (resp !== null && resp !== void 0 && resp.isSuccessful) {
        toast('success', {
          body: [t('portfolios_properties_page.portfolio_deleted')]
        });
        setIsDeletePortfolioModalOpen(false);
        triggerRefresh();
      }
    }).catch(error => {
      toast('error', {
        body: [error]
      });
    });
  };
  const _useState9 = useState(false),
    _useState0 = _slicedToArray(_useState9, 2),
    isRenamePortfolioModalOpen = _useState0[0],
    setIsRenamePortfolioModalOpen = _useState0[1];
  const _useState1 = useState(null),
    _useState10 = _slicedToArray(_useState1, 2),
    renameModalProps = _useState10[0],
    setRenameModalProps = _useState10[1];
  const handleShowCreateEditPortfolioTrigger = value => {
    setIsRenamePortfolioModalOpen(value);
    setRenameModalProps(null);
  };
  useEffect(() => {
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Container, {
    className: "".concat(classes.containerDefault, " ").concat(selectedRows.length > 0 ? classes.containerSmall : '')
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.tableTitle
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.tableTitleBlock
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "h3"
  }, isSelectAllPropertiesEnabled ? t('portfolios_properties_page.all_properties') : selectedPortfolio === null || selectedPortfolio === void 0 ? void 0 : selectedPortfolio.name)), /*#__PURE__*/React.createElement("div", null, !isSelectAllPropertiesEnabled && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: classes.avatarsBlock
  }, selectedPortfolio === null || selectedPortfolio === void 0 ? void 0 : selectedPortfolio.accessResponses.map(item => {
    return /*#__PURE__*/React.createElement("div", {
      className: classes.avatar
    }, /*#__PURE__*/React.createElement(BasicTooltip, {
      title: "".concat(item.firstName, " ").concat(item.lastName),
      placement: "top"
    }, item.firstName.toUpperCase().charAt(0)));
  })), /*#__PURE__*/React.createElement(Button, {
    size: "medium",
    variant: "actionIcon",
    onClick: event => {
      event.stopPropagation();
      handleShowManageAccessModal(true, null, selectedPortfolio);
    },
    'custom-attribute': '742-properties-table'
  }, /*#__PURE__*/React.createElement(Icon, {
    type: "team-group"
  }), t('team_page.manage_access')), /*#__PURE__*/React.createElement(PortfolioActionsMenu, {
    portfolioId: selectedPortfolio === null || selectedPortfolio === void 0 ? void 0 : selectedPortfolio.id,
    selectedPortfolio: selectedPortfolio,
    menuTriggerExternal: /*#__PURE__*/React.createElement(Icon, {
      type: "dotdotdot"
    }),
    triggerDeleteModalOpen: value => {
      setIsDeletePortfolioModalOpen(value);
    },
    setDeleteModalProps: setDeleteModalProps,
    triggerRenameModalOpen: value => {
      setIsRenamePortfolioModalOpen(value);
    },
    setRenameModalProps: setRenameModalProps,
    handleShowManageAccessModal: handleShowManageAccessModal
  })))), !!propertiesList.length ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: classes.searchBar
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.searchField
  }, /*#__PURE__*/React.createElement(InputWithIcon, {
    icon: /*#__PURE__*/React.createElement(Icon, {
      type: "search"
    })
  }, /*#__PURE__*/React.createElement(TextField, {
    id: "residencies-search",
    label: t('portfolios_properties_page.search_for_property'),
    variant: "outlined",
    value: searchKey,
    onChange: e => {
      var _e$target;
      return setSearchKey(e === null || e === void 0 || (_e$target = e.target) === null || _e$target === void 0 ? void 0 : _e$target.value);
    },
    fullWidth: true
  })))), /*#__PURE__*/React.createElement(PropertiesDataGrid, {
    isSelectAllPropertiesEnabled: isSelectAllPropertiesEnabled,
    updateRowsCount: setSelectedRows,
    selectedRows: selectedRows,
    setSelectedRows: setSelectedRows,
    searchKey: searchKey,
    propertiesList: propertiesList.filter(i => {
      const searchPhrase = new RegExp(searchKey, 'gi');
      return searchKey.length > 0 ? " ".concat(i.propertyAddress).search(searchPhrase) > 0 : true;
    }),
    isLoadingExt: isLoadingExt,
    handleShowEnrollModal: handleShowEnrollModal,
    setShowEnrollModalSelectedPropertyId: setShowEnrollModalSelectedPropertyId,
    triggerRefresh: triggerRefresh,
    handleShowManageAccessModal: handleShowManageAccessModal,
    handleShowAutoBillingBatchModalModal: handleShowAutoBillingBatchModalModal
  })) : /*#__PURE__*/React.createElement("div", {
    className: classes.emptyState
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.emptyStateContainer
  }, /*#__PURE__*/React.createElement("div", {
    className: "".concat(classes.smSection, " ").concat(classes.emptyStateContainerItem)
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "h3"
  }, " ", t('portfolios_properties_page.new_portfolio'))), /*#__PURE__*/React.createElement("div", {
    className: "".concat(classes.xsSection, " ").concat(classes.emptyStateContainerItem)
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "body2"
  }, t('portfolios_properties_page.empty_portfolio_info'))), /*#__PURE__*/React.createElement("div", {
    className: "".concat(classes.xsSection, " ").concat(classes.emptyStateContainerItem, " ").concat(classes.emptyStateContainerItemAddPropertyButton)
  }, /*#__PURE__*/React.createElement(Button, {
    component: RouterLink,
    id: "addNewProperty",
    to: "/new_property",
    size: "regular",
    variant: "actionIcon",
    'custom-attribute': '744-properties-table'
  }, /*#__PURE__*/React.createElement(Icon, {
    type: "building"
  }), /*#__PURE__*/React.createElement("span", {
    className: "actionText"
  }, " ", t('portfolios_properties_page.add_new_property'))))))), /*#__PURE__*/React.createElement(CreateEditPortfolioModal, {
    customTrigger: null,
    isEditMode: true,
    existingPortfolio: selectedPortfolio || renameModalProps,
    triggerRefresh: triggerRefresh,
    showModal: isRenamePortfolioModalOpen,
    handleShowModal: handleShowCreateEditPortfolioTrigger
  }), /*#__PURE__*/React.createElement(SimpleConfirmationModal, {
    externalIsOpen: isDeletePortfolioModalOpen,
    headerText: t('portfolios_properties_page.delete_portfolio'),
    bodyText: t('portfolios_properties_page.you_are_about_to_delete_portfolio', {
      portfolioName: deleteModalProps === null || deleteModalProps === void 0 || (_deleteModalProps$sel = deleteModalProps.selectedPortfolio) === null || _deleteModalProps$sel === void 0 ? void 0 : _deleteModalProps$sel.name
    }),
    callBack: _ref2 => {
      let action = _ref2.action,
        objectToPassOver = _ref2.objectToPassOver;
      if (action === 'submit') {
        deletePortfolioHandler(objectToPassOver);
      }
      setIsDeletePortfolioModalOpen(false);
    }
  }), !!store.portfoliosMultiActionStore.selectedItems.length && /*#__PURE__*/React.createElement(PropertiesBatchActions, {
    triggerRefresh: triggerRefresh
  }), /*#__PURE__*/React.createElement(BackdropLoader, {
    isOpen: isLoadingExt
  }));
});